import * as React from 'react'

const IconX = (props) => (
  <svg width={24} height={24} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M16.596 4.782 12 9.38 7.404 4.782a1.5 1.5 0 1 0-2.122 2.122L9.88 11.5l-4.597 4.596a1.5 1.5 0 1 0 2.122 2.122L12 13.62l4.596 4.597a1.5 1.5 0 1 0 2.122-2.122L14.12 11.5l4.597-4.596a1.5 1.5 0 1 0-2.122-2.122'
      fill='#00B2E3'
      fillRule='evenodd'
    />
  </svg>
)

export default IconX
